export * from './deck/Deck.js';
export * from './deck/Decks.js';
export * from './deck/SmithWaite.js';
export * from './deck/Standard.js';
export var GameRuleSets;
(function (GameRuleSets) {
    GameRuleSets["Base"] = "Base";
    GameRuleSets["WinThisGame"] = "Win This Game";
    GameRuleSets["OhHell"] = "Oh Hell";
})(GameRuleSets || (GameRuleSets = {}));
export var CmdResultTypes;
(function (CmdResultTypes) {
    CmdResultTypes["Success"] = "SUCCESS";
    CmdResultTypes["Failure"] = "FAILURE";
})(CmdResultTypes || (CmdResultTypes = {}));
export function isSuccess(result) {
    return result.result === CmdResultTypes.Success;
}
//# sourceMappingURL=index.js.map